<ifc-broker-api-key-details *ngIf="data" [inputData]="data"></ifc-broker-api-key-details>